// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c0731b1a","108":"f03cd329","146":"ba4889c6","307":"6cc1f162","313":"02536167","459":"2e17fe97","491":"5fea02d4","887":"e120a192"}[chunkId] + ".chunk.js";
};